import React from "react";
import { Row, Col, Card, Input } from 'antd';
import Meta from "antd/es/card/Meta";
import CanCan from "../CanCan";
import { Button } from "@public/ui-toolkit";
import { useHistory } from "react-router";
const { Search } = Input;

export default function FundStatCard({
  funds,
  isSearchEnable = false,
  currentFund,
  setCurrentFund,
  onClick,
  fitlerFunds,
  id,
  notes
}) {
  const history = useHistory();
  const [show, setShow] = React.useState(false);
  return (
    <Row className="component" style={{ paddingTop: "10px" }}>
      {isSearchEnable ? (
        <>
          <Col span={show ? 16 : 19} className="component-header" style={{ marginTop: "5px" }} >
            <div className="stylish-title text-blue Fund-FontSize">My Funds</div>
          </Col>
          <Col span={4} className="component-header">
            {/* <CanCan permissionName={Permissions?.FUND_CREATE?.name}> */}
            <Button
              btnStyle={{ padding: "4px 12px" }}
              btnName="Create Fund Request"
              btnType={"!primary"}
              onClick={() => {
                history.push("/createfund");
              }}
            />
            {/* </CanCan> */}
          </Col>
          <Col className="component-header" span={show ? 4 : 1}>
            {show ? (
              <Search placeholder="Search Fund" onChange={(e) => fitlerFunds(e.target.value)} onSearch={(e) => fitlerFunds(e)} />
            ) : (
              <i className="fa fa-search" style={{ padding: "4px 4px", fontSize: "22px", cursor : "pointer" }} onClick={() => setShow(!show)}></i>
            )}
          </Col>
        </>
      ) : (
        <Col span={20} className="component-header" style={{ marginTop: "5px" }} >
          <div className="Fund-FontSize">{"Funds (" + funds?.length + ")"}</div>
        </Col>
      )}
      <Col span={24} className="component-body" style={{ marginTop: "0px" }}>
        <Row className="flex-nowrap scrollbar">
          {funds?.map((fundDetail, index) => {
            return (
              <>

                <Col span={6} className="p-1 pb-2">
                  <Card
                    key={index}
                    onClick={() => {
                      if (id !== window._env_.EthosFundId) {
                        setCurrentFund(fundDetail?.id);
                        onClick(fundDetail?.id);
                      }
                    }}
                    hoverable={id === window._env_.EthosFundId ? false : true}
                    bodyStyle={{ padding: "10px", borderRadius: "5%" }}
                    className={`fund-overview-card ${fundDetail?.id == currentFund && "selected"}`}>

                    <Meta className="ml-2 mb-2 text-center" title=
                      {<div><span className="Fund-FontSize" style={{ color: "#276598"}}>{fundDetail?.name}</span>
                      {(() => {
                          if (isSearchEnable) {
                            if (fundDetail?.isPrivate) {
                              return (<i className="fa fa-lock ml-2" style={{ color: "red" }}></i>)
                            } else {
                              return(<i className="fa fa-globe ml-2" style={{ color: "#3ac1b5" }}></i>)
                            }}
                            else{
                              if (fundDetail.followed) {
                                return(<i className="fa fa-check-square ml-2" style={{ color: "#3ac1b5" }}></i>)
                              }else if(id === window._env_.EthosFundId){
                                return (<i className="ml-1 mb-0" style={{ color: "#276598",fontSize : "20px" }}>*</i>)
                              }
                        }
                      })()}
                        {/* {isSearchEnable ? (
                          fundDetail?.isPrivate ? <i className="fa fa-lock ml-2" style={{ color: "red" }}></i> : <i className="fa fa-globe ml-2" style={{ color: "#3ac1b5" }}></i>
                        ) : (
                          fundDetail.followed && <i className="fa fa-check-square ml-2" style={{ color: "#3ac1b5" }}></i>
                        )} */}
                      </div>
                      } />
                    <Row>
                      <Col>
                        <Row className="text-center" >
                          <Col span={10} offset={1}>
                            <div class="ml-2">
                              <div className="Fund-FontSize">{fundDetail.ytd ? parseFloat(fundDetail.ytd)?.toFixed(2) + "%" : "N/A"}</div>
                              <h4>YTD</h4>
                            </div>

                          </Col>
                          <Col span={10} offset={1}>
                            <div class="ml-2">
                              <div className="Fund-FontSize">{fundDetail.annualizedReturn ? parseFloat(fundDetail.annualizedReturn)?.toFixed(2) + "%" : "N/A"}</div>
                              <h4>Ann. Returns</h4>
                            </div>
                          </Col>
                          <Col span={10} offset={1}>
                            <div class="ml-2">
                              <div className="Fund-FontSize">{fundDetail.annualVolatility ? parseFloat(fundDetail.annualVolatility)?.toFixed(2) + "%" : "N/A"}</div>
                              <h4>Ann. Volatility</h4>
                            </div>
                          </Col>
                          <Col span={10} offset={1}>
                            <div class="ml-2">
                              <div className="Fund-FontSize">{fundDetail.monthlyReturn ? parseFloat(fundDetail.monthlyReturn)?.toFixed(2) + "%" : "N/A"}</div>
                              <h4>Latest Month</h4>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </>
            )
          })}
          
          {(() => {
                  if (id === window._env_.EthosFundId) {
                    return (
                      <Col span={11} className="p-1 pb-2">
                        <Card
                          hoverable={true}
                          bodyStyle={{ padding: "10px", borderRadius: "5%" }}
                          className={`fund-overview-card}`}>
                          
                          <Meta className="ml-2 mb-2 text-center" title=
                            {<div><span className="Fund-FontSize" style={{ color: "#276598" }}>{"Foot Note"}</span> <i className="ml-1 mb-0" style={{ color: "#276598",fontSize : "20px" }}>*</i></div>} description={notes} />
                        </Card>
                      </Col>
                    )
                  }
                })()}
        </Row>
      </Col>
    </Row>)
}
